package ai.wagemix

import ai.wagemix.logic.WMNavigationRequest
import ai.wagemix.logic.WMRoutes
import ai.wagemix.web.components.WMIconButton
import ai.wagemix.web.components.WMIconGlyph
import ai.wagemix.web.components.WMLogo
import ai.wagemix.web.screens.WMWebStrings
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window

/** The site's strings; one place to swap in a localisation. */
val siteStrings: WMWebStrings get() = WMWebStrings.english

fun AppGlobals.env(): String = get("SITE_ENV") ?: error("SITE_ENV not found")
fun AppGlobals.siteUrl(): String = get("SITE_URL") ?: error("SITE_URL not found")

/** Maps a presenter's navigation request onto the router (web-screen playbook, Step 4). */
fun PageContext.navigate(request: WMNavigationRequest) {
    when (request) {
        is WMNavigationRequest.Route -> router.navigateTo(request.path)
        is WMNavigationRequest.External -> window.location.href = request.url
    }
}

@Composable
fun SiteLogo(markOnly: Boolean = false) {
    // The mark and wordmark are the way back to the landing page from every layout.
    Link(path = WMRoutes.HOME, variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)) {
        WMLogo(
            markLightSrc = "/wagemix_logo-light.svg",
            markDarkSrc = "/wagemix_logo-dark.svg",
            markOnly = markOnly
        )
    }
}

@Composable
fun ThemeToggle(strings: WMWebStrings = siteStrings) {
    var colorMode by ColorMode.currentState
    WMIconButton(
        glyph = if (colorMode.isLight) WMIconGlyph.Moon else WMIconGlyph.Sun,
        accessibilityString = strings.shell.theme,
        modifier = Modifier
    ) { colorMode = colorMode.opposite }
}
